import React from 'react';
import { Globe } from 'lucide-react';

/** Hierarchy row badge for lesson/quiz/exercise content designed for non-Farsi users. */
export const EnglishLockedHierarchyIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    data-tooltip="Designed for non-Farsi users (English-primary content)"
    className={`tooltip inline-flex shrink-0 items-center ${className}`}
    title="Designed for non-Farsi users (English-primary content)"
  >
    <Globe className="h-3.5 w-3.5 text-sky-600" aria-hidden />
  </span>
);
